module.exports = __webpack_public_path__ + "static/media/md-arrow-up.46ca744e.svg";